// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container___YWC_"};